import { axiosPost } from '../AxiosApi';
import { sendRequest } from '../AxiosRequest';

export const readVersionList = async () => {
  const payload = {
    path: '/version/list',
  };
  return await sendRequest(payload, 'readVersionList', axiosPost);
};

export const readVersionDetail = async (versionId: string) => {
  const payload = {
    path: '/version-detail',
    body: { versionId },
  };
  return await sendRequest(payload, 'readVersionDetail', axiosPost);
};
